{
    "NAME": "Liste d'état du module TelLangue",
    "TelModuleStatusList_Title": "État du module téléphonique",
    "TelModuleStatusList_Column_TelSys": "Serveur de téléphonie",
    "TelModuleStatusList_Column_ClassName": "Nom de la classe",
    "TelModuleStatusList_Column_Type": "Taper",
    "TelModuleStatusList_Column_Version": "Version",
    "TelModuleStatusList_Column_Status": "Statut",
    "TelModuleStatusList_Column_LastError": "Dernière erreur",
    "TelModuleStatusList_Column_LastErrorDateTime": "Date et heure de la dernière erreur",
    "TelModuleStatusList_Empty": "Aucun élément d'état du module téléphonique n'est disponible."
}